//import { IntlProvider } from 'react-intl';
//import { IntlProvider } from 'react-intl';
//import messages from '../index';
//import { getLang } from './store';
//import { useSelector } from 'react-redux';
// import { getDefaultLanguage } from 'src/tools/tools';
//import { useHistory } from 'react-router';
import enGB from 'antd/es/locale/en_GB';
import zhCN from 'antd/es/locale/zh_CN';
import zhHK from 'antd/es/locale/zh_HK';
import React from 'react'; //{ Fragment }
import { get } from 'lodash';
import { ELang } from '../../src/types/common/language';
import { generateKey } from 'src/tools/getUserInfo';
import { SYS_LANGUAGE, GENERAL } from 'src/tools/constant';
import { IMAGE_URL } from 'src/tools/constant';
import axios from 'axios';
import { useRequest, useLocalStorageState } from 'ahooks';
import { Spin } from 'antd';
import GeneralJSON from '../../portal-bundle.json';

export const I18nContext = React.createContext<any>(null);
const getI18nBaseURL = () => {
  if (['test2', 'dev'].includes(process.env.REACT_ENV)) {
    return 'portal2-i18n-json-dev';
  }
  if (['pre'].includes(process.env.REACT_ENV)) {
    return 'portal2-i18n-json-pre';
  }
  if (['prod'].includes(process.env.REACT_ENV)) {
    return 'portal2-i18n-json';
  }
  return 'portal2-i18n-json-dev';
};
export const baseURL = `${IMAGE_URL}${getI18nBaseURL()}/`; //for i18n
export const languageList = [ELang['zh-HK'], ELang['zh-CN'], ELang['en-GB']];
export const languageLabel = {
  [ELang['zh-HK']]: '繁體中文',
  [ELang['zh-CN']]: '简体中文',
  [ELang['en-GB']]: 'English',
};
// Ant Design 内置的语言包
export const languageAntdLocale = {
  [ELang['zh-HK']]: zhHK,
  [ELang['zh-CN']]: zhCN,
  [ELang['en-GB']]: enGB,
};

const getDefaultLanguage = () => {
  const browserLang: any =
    get(navigator, 'language') || get(navigator, 'userLanguage') || 'en-GB';
  if (languageList.includes(browserLang)) {
    return browserLang;
  } else {
    if (browserLang.startsWith('en')) {
      return 'en-GB';
    }
    if (browserLang.startsWith('zh')) {
      return 'zh-HK';
    }
    return 'en-GB';
  }
};

const Provider = ({ children }) => {
  const k = generateKey(SYS_LANGUAGE);
  // const r = useHistory();
  // console.log('r', r);
  //const i18n = useSelector(getLang());
  const defaultLanguage = getDefaultLanguage();

  const [lang, setLang] = useLocalStorageState<any>(k, defaultLanguage);
  const [i18n, setI18n] = React.useState<any>({});
  const [reloading, setReloading] = React.useState(false);
  //const JsonInDefault = getGeneralJSON();
  const [generalI18n, setGeneralI18n] = React.useState<any>(
    get(GeneralJSON, lang),
  );
  React.useEffect(() => {
    if (!localStorage.getItem(k) || localStorage.getItem(k) === '') {
      setLang(defaultLanguage);
    }
  }, []);
  useRequest(
    () => {
      return axios.get(`${baseURL}${GENERAL}_${lang}.json`);
    },
    {
      onSuccess: (r) => {
        // console.log('l', l);
        const data = get(r, 'data');
        setGeneralI18n({
          ...data,
          ...(generalI18n || {}),
        });
      },
    },
  );
  // React.useEffect(() => {
  //   const req = () => axios.get(`${baseURL}${GENERAL}_${lang}.json`, {});
  // }, []);
  return (
    <I18nContext.Provider
      value={{
        i18n,
        generalI18n,
        setI18n,
        lang,
        setLang: (lang) => {
          //console.log(123);
          setLang(lang);
          location.reload();
        },
        setReloading,
      }}>
      <Spin {...{ spinning: reloading }}>{children}</Spin>
    </I18nContext.Provider>
  );
};

export default Provider;
